export const PRESENTATION_INIT_DATA = 'PRESENTATION_INIT_DATA';
export const SLIDE_DATA = 'SLIDE_DATA';
export const SLIDE_STATIC_DATA = 'SLIDE_STATIC_DATA';
export const SLIDE_PREVIEW = 'SLIDE_PREVIEW';
export const PPTS_OPEN = 'PPTS_OPEN';
export const PPTS_CLOUD = 'PPTS_CLOUD';
export const SESSION_CODE = 'SESSION_CODE';
export const USER_COUNT = 'USER_COUNT';
export const TITLE_BAR = 'TITLE_BAR';
export const LANGUAGE = 'LANGUAGE';
export const ORIENTATION = 'ORIENTATION';
export const KEYBOARD = 'KEYBOARD';
export const CONFIG_SHARE = 'CONFIG_SHARE';
/*export const ADD_PPT= 'ADD_PPT';
export const REMOVE_PPT= 'REMOVE_PPT';*/
export const SELECTED_PPT= 'SELECTED_PPT';
export const SLIDE_INDEX= 'SLIDE_INDEX';
export const FULLSCREEN= 'FULLSCREEN';
export const OPEN_MODAL= 'OPEN_MODAL';
export const CLOSE_MODAL= 'CLOSE_MODAL';
export const CLOSE_CONFIG= 'CLOSE_CONFIG';
export const OPEN_CONFIG= 'OPEN_CONFIG';
export const PRESENTATION_MODE_CONFIG= 'PRESENTATION_MODE_CONFIG';
export const SUBMENU_CONFIG= 'SUBMENU_CONFIG';
export const HOTPLUGIN_INFO= 'HOTPLUGIN_INFO';
export const SET_AUDITORIUM_MODE= 'SET_AUDITORIUM_MODE';

export const STATE_LOADING_PRESENTATION = 'STATE_PRESENT';
export const ID_SLIDE_COMMENT = "[TOGLEA]-";
export const FONT_FAMILY = 'Roboto-Regular';

export const LANGUAGES = [  { title:"English", value:"en"}, 
                            { title:"Español", value:"es"} ];

// URL_SERVICES is defined in compile time as global const by webpack settings:
//export const URL_SERVICES = "http://localhost:1337/";//para pruebas locales
//export const URL_SERVICES = window.location.protocol + "//app.flipwit.com/sails/";//para produccion

export const COLOR = {
    BACKGROUND: '#EEEEEE',
    LOGIN_GOOGLE_BUTTON: '#CF3029',
    CARD_BACKGROUND: '#FAFAFA',   
    CARD_BORDER: '#CECECE',
    JOIN_BUTTON: '#1564C0',
    TEXT_BUTTON: '#E1EBF5',
    TEXT: '#000000',
    TEXT_DESC: '#000000',
    INPUT_TEXT: '#F2F2F2',
    INPUT_BORDER: '#D5D5D5',
    TEXT_WHITE: '#FFFFFF',
    FLIPWIT_COLOR_0: '#F1511E',
    FLIPWIT_COLOR_1: '#FF5722',
    FLIPWIT_COLOR_2: '#FF754A',
    FLIPWIT_COLOR_3: '#FF9472',
    FLIPWIT_COLOR_4: '#FFB29A',
    FLIPWIT_COLOR_5: '#FFD1C2',
    /*FLIPWIT_COLOR_1: '#FF5722',
    FLIPWIT_COLOR_2: '#FF6636',
    FLIPWIT_COLOR_3: '#FF754A',
    FLIPWIT_COLOR_4: '#FF845E',
    FLIPWIT_COLOR_5: '#FF9472',*/
}

/*export const TEXTS = {
    TITLE_JOIN: 'Soy asistente',
    ENTER_CODE: 'Ingresar código',
    JOIN_BUTTON: 'UNIRME',
    
    TITLE_EXHIBITOR: 'Soy un expositor',
    EXHIBITOR_BUTTON: 'Ingresar',
    START_PRESENTATION: 'Iniciar presentación',
    FINISH_PRESENTATION: 'Minimizar presentación',
    CONFIG_PRESENTATION: 'Configurar presentación',
    INSERT_SURVEY: 'Insertar pregunta',
    USERS: 'Usuarios',
    NOTES: 'Notas',
    CONFUSED: '¿Está confundido?',
    DESC_EXHIBITOR: 'Si deseas exponer un tema o editar una presentación debes ingresar como expositor',//se puso estos saltos para que quedaran casi del mismo tamaño los 2 cuadros
    DESC_JOIN: 'Escribe el código de la presentación para unirte',
    TITLE_NICK: 'Únete usando un apodo',
    DESC_NICK: 'Ingresa un apodo para unirte sin iniciar sesión',
    ENTER_NICK: 'Ingresar apodo',
    TITLE_LOGIN: 'Inicia sesión para continuar',
    DESC_LOGIN_CREDENTIALS: 'Usa tu usuario y contraseña',
    LABEL_USERNAME: 'Correo electrónico',
    LABEL_PASSWORD: 'Contraseña',
    DESC_LOGIN_GOOGLE: 'ó Inicia sesión con tu cuenta de Gmail',
    LOGIN_PLAIN_BUTTON: 'INICIA SESIÓN',
    LOGIN_GOOGLE_BUTTON: 'INICIA SESIÓN CON GOOGLE',
    LOGIN_ERROR_EMAIL: 'Ingresa un email válido',
    LOGIN_ERROR_NOT_EXISTS: 'No existe un usuario asociado al email que ingresaste. Verifica tu email',
    LOGIN_ERROR_PASSWORD: 'La contraseña no es correcta',
    LOGIN_NOT_ACCOUNT_YET: '¿Aún no tienes una cuenta?',
    LOGIN_CREATE_YOUR_ACCOUNT: ' - Crea tu cuenta Flipwit - ',
    LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
    TITLE_LOCAL_DOCS: 'Presentaciones locales',
    DESC_LOCAL_DOCS: 'Las siguientes presentaciones están abiertas en tu PC. Selecciona la presentación que deseas utilizar con Flipwit:',
    TITLE_CLOUD_DOCS: 'Presentaciones en la nube',
    DESC_CLOUD_DOCS: 'Las siguientes presentaciones están almacenadas en la nube de Flipwit. Seleccione la presentación que desea utilizar con Flipwit:',
    SELECT: 'Select',
    SELECT_PRESENTATION_TITLE_DIALOG: "Cerrar presentación",
    OK: "Aceptar",
    SELECT_PRESENTATION_DESC_DIALOG: "Parece que tu presentación actual está cerrada, selecciona una presentación activa.",
    ERROR_JOIN_TITLE: 'ERROR',
    ERROR_JOIN_DESC: 'No hay ninguna presentación con el código introducido, verifica el código e inténtalo de nuevo.',
    ACT_FOR_APP_DESKTOP:'Lo sentimos',
    ACT_FOR_APP_DESKTOP_DESC:'Esta actividad sólo se puede utilizar con la versión para PC.',
    NAV_MENU: {
        CHANGE_PRESENTATION: 'Selecciona otra presentación',
        JOIN_PRESENTATION: 'Unirme a una presentación',
        LOGOUT: 'Cerrar sesión de usuario'
    },
    INSERT_TUTORIAL: 'Insertar ayuda conexión',
    INSERT_URL: 'Insertar página web',    
    INSERT_CONTEST: 'Insertar concurso',
    TRIAL_DAY_LEFT: 'Te queda 1 día de tu suscripción Flipwit',
    TRIAL_DAYS_LEFT: 'Te quedan [DAYS_LEFT] días de tu suscripción Flipwit',
    RENEW_PLAN_NOW: 'Renueva tu plan ahora',
    SUBSCRIPTION_END: 'Tu suscripción se ha vencido',
    SUBSCRIPTION_DESC_END: 'Puedes renovar tu suscripción entrando al Portal Web de Flipwit y pagando online',
    LOADING_INFO: "Cargando información de la presentación",
    STATES_INIT_PRESENTATION: {
      0: "Generando previews",
      1: "Guardando previews",
      2: "Presentación guardada en la nube",
      3: ""
    }
}

export const TITLES = {
    PRESENTATIONMODE: 'Modo presentación',
    JOINOPTIONS: 'Opciones para unirte',
    SELECTPRESENTATION: 'Selección de presentación',
    MAINMENU: 'Menú principal',
    PRESENTATIONUSER: 'Presentación audiencia',
    PLUGINVIEWER: 'Edición de actividad',
    BLOCKEDUSER: 'Tu cuenta Flipwit'
}*/

export const TEXT_SIZES = {
    TITLE: 2.6 ,
    TEXT: 1,
    BUTTON: 1,
    CLOCK: 1.8,
    ARROWS: 1.8,
}

export const PlatformEnum = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  WEB: "WEB",
  ELECTRON: "ELECTRON",
}



// WEBPACK FOOTER //
// ./src/containers/App/constants.js